export default __webpack_public_path__ + "locales/sk/PDFFormDialog.json?hash=9a18dc6144395e84b5ce2c1257251da4";